export const defineClientAppSetup = (clientAppSetup) => clientAppSetup;
